// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Q1t-2","header":"styles_header__9OsVV"};